import React from "react";
import ChrMetric from "../../generic/PageUI/Compound/Metric/ChrMetric";

// WidgetBodyWrapper iterates and renders the array of metrics by default. Incase of any customization needed instead, pass the required content as the children of WidgetBodyWrapper
const WidgetBodyWrapper = (props) => {
  const { bodyClassName, metrics, additionalClassNames = "", wrapperPadding = "p-3" } = props;

  return (
    <div className={ `grid-container-sm ${wrapperPadding} mb-auto ${bodyClassName} ${additionalClassNames}` }>
      {
        props.children || (
          metrics.map((metric) => {
            return (<ChrMetric key={ metric.uId } { ...metric } />);
          })
        )
      }
    </div>
  );
};

export default WidgetBodyWrapper;